export default __webpack_public_path__ + "images/bad20a95ceb350bee931316b9da5ae8e-macbook_2.png";